module.exports = "<div class=\"navigation\">\n  <a href=\"/\"><h1 class=\"title\">Atlanta <span></span> Greenspaces</h1></a>\n</div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main